import { render, staticRenderFns } from "./ThirdStepStatus.vue?vue&type=template&id=738afa60&scoped=true&"
import script from "./ThirdStepStatus.vue?vue&type=script&lang=js&"
export * from "./ThirdStepStatus.vue?vue&type=script&lang=js&"
import style0 from "./ThirdStepStatus.vue?vue&type=style&index=0&id=738afa60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738afa60",
  null
  
)

export default component.exports